module.exports = __webpack_public_path__ + "img/logo.2008bfc8.svg";